import React from 'react'
import { AppBasicTable, AppResultsSkeleton } from "@components"
import { priceColumn } from "Pages/AnalyzersV2/@components/CategoriesTable/columns"
import { isAnalyzerLoading } from "Pages/AnalyzersV2/@signals"
import AnalyzerHeaderTable from "Pages/AnalyzersV2/@components/CategoriesTable/Header"
import AnalyzerCategoriesTableToolbar from './Toolbar'
import { dsColorNew } from "@palette"


export default function AnalyzerCategoriesTable({ xList, tableData, evolutionData, setFullScreen, isFullScreen, tableSx = {} }) {
    let rowIndex = 0
    if (isAnalyzerLoading.value) return <AppResultsSkeleton rows={7} columns={8}/>

    if (!tableData?.length) return null

    return <AppBasicTable
        data={tableData}
        cardProps={{ 'data-tour-id': 'tour-categories-table' }}
        Components={{
            Title: () => <AnalyzerCategoriesTableToolbar setFullScreen={setFullScreen} isFullScreen={isFullScreen} />,
        }}
        columns={xList?.map(column => priceColumn(column, tableData))}
        headers={[xList?.map(item => ({ render: () => <AnalyzerHeaderTable key={item} label={item} {...evolutionData}/> }))]}
        setHeaderCellProps={() => ({
            sx: {
                p: .5,
                backgroundColor: dsColorNew.tableHead,
            }
        })}
        setBodyCellProps={(_, row, idx, rowIdx) => {
            if (rowIdx === 0) {
                rowIndex++
            }
            return {
                sx: {
                    backgroundColor: rowIndex % 2 !== 0 ? dsColorNew.white : dsColorNew.tableRowAlt,
                }
            }
        }}
        sx={{
            padding: 0,
            '& td': {
                padding: '6px 4px',
                '& div': {
                    padding: 0,
                    height: '100%',
                },
            },
            ...(tableSx.sx || {})
        }}
    />

}